<template>
  <Box>
    <template #handle>
      <Btn v-if="hasPermi('system:clientversioninfo:uploadClient')" @click="addItem">新增记录</Btn>
    </template>
    <template #content>
      <div class="table_main">
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :selection="false" :loading="loading">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                    (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
                <span v-if="data.head.handle == 'releaseScope'">{{
                    (
                      releaseScopes.find(
                        (item) => item.value == data.data.releaseScope
                      ) || { label: "" }
                    ).label
                }}</span>
                <span v-if="data.head.handle == 'softtype'">{{
                    (
                      softtypes.find(
                        (item) => item.value == data.data.softtype
                      ) || { label: "" }
                    ).label
                }}</span>
                <div v-if="data.head.handle == 'releaseState'">
                  {{ data.data.releaseState ? "已发布" : "未发布" }}
                  <Btn type="text" @click="handleRelease(data.data)">
                    {{ data.data.releaseState ? "取消发布" : "允许发布" }}
                  </Btn>
                </div>
                <div v-if="data.head.handle == 'btns'">
                  <Btn v-if="
                    hasPermi(
                      'system:clientversioninfo:clientVersionInfoById'
                    )
                  " type="text" @click="handleItem(data.data, '升级详情')">升级说明详情</Btn>
                  <Btn type="text" v-if="hasPermi('system:sbinfo:releaseScopeList')"
                    @click="toPath(`/ReleaseNameListSetUp`, data.data)">发布名单设置</Btn>
                  <Btn type="text" v-if="hasPermi('system:sbsj:upgradeStatusList')"
                    @click="toPath(`/UpgradeStatusList`, data.data)">设备升级状态列表</Btn>
                  <!--<Btn type="text" v-if="hasPermi('system:sbsj:upgradedSbList')"-->
                  <!--  @click="toPath(`/UpdatedDeviceList`, data.data)">已升级设备列表</Btn>-->
                  <Btn type="text" @click="handleItem(data.data, '数据修改')">数据修改</Btn>
                </div>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="total, sizes, prev, pager, next" :total="pageData.total" :page-sizes = "[10, 20, 50, 100]"
            :current-page.sync="pageData.page" :page-size.sync="pageData.pageSize" @size-change="query" @current-change="getList">
          </el-pagination>
        </div>
      </div>
      <Drawer :open="open" @changeOpen="changeOpen" :title="drawerTitle">
        <template #content>
          <el-form :model="addForm" ref="addForm" label-width="130px" :class="[
            'demo-ruleForm',
            'formBox',
            disabledTitles.includes(drawerTitle) ? 'disabled' : '',
          ]" :rules="rules" :disabled="disabledTitles.includes(drawerTitle)">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="版本标识：" prop="versionTag">
                  <el-input-number size="small" v-model.number="addForm.versionTag" controls-position="right"
                    :disabled="drawerTitle == '数据修改'" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="版本号：" prop="version">
                  <el-input size="small" v-model="addForm.version" :disabled="drawerTitle == '数据修改'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="升级详情：" prop="context">
                  <el-input type="textarea" v-model="addForm.context"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="发布范围类型：" prop="releaseScope">
                  <el-radio-group size="small" v-model="addForm.releaseScope">
                    <el-radio v-for="item in releaseScopes" :key="item.value" :label="item.value">{{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="程序类型：" prop="softtype">
                  <el-radio-group size="small" v-model="addForm.softtype">
                    <el-radio v-for="item in softtypes" :key="item.value" :label="item.value">{{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="附件：">
                  <Upload ref="upload" :fileList="fileList" :accept="'.zip'" :limit="1"
                    :disabled="disabledTitles.includes(drawerTitle)" :action="action" :params="addForm"
                    :canDown="canDown" @success="success" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <template #footer v-if="!disabledTitles.includes(drawerTitle)">
          <Btn type="blue" @click="commitData">提交</Btn>
          <Btn @click="closeDrawer">取消</Btn>
        </template>
      </Drawer>
    </template>
  </Box>
</template>

<script>
import {
  clientVersionInfoList,
  clientVersionInfoById,
  updateclientVersionInfoById,
  releaseStatus,
} from "@/api/CollectionSystemSetUpManagement";
import Upload from "@/components/upload";
import drawerMixins from "@/components/drawer/drawer";
import permMixin from "@/mixins/perm";
import { releaseScopes, softtypes } from "@/utils/status";
import rules, { bt } from "@/utils/formRules";
import jq from "jquery";
export default {
  mixins: [drawerMixins, permMixin],
  data() {
    return {
      releaseScopes,
      softtypes,
      loading: false,
      pageData: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      rules: {
        versionTag: rules.versionTag,
      },
      maxA: 0,
      maxB: 0,
      tableData: [],
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "center",
        },
        {
          prop: "version",
          label: "版本号",
        },
        {
          prop: "softtype",
          label: "程序类型",
          handle: "softtype",
        },
        {
          prop: "releaseScope",
          label: "发布范围类型",
          handle: "releaseScope",
          minWidth: 120,
          textAlign: "center",
        },
        {
          prop: "releaseState",
          label: "发布状态",
          handle: "releaseState",
        },
        {
          prop: "createUser",
          label: "发布人",
        },
        {
          prop: "cz",
          label: "操作",
          handle: "btns",
          fixed: "right",
          width: 460,
        },
      ],
      addForm: {
        versionTag: 0,
        version: "",
        context: "",
        releaseScope: 1,
        softtype: 0,
      },
      initAddForm: {
        versionTag: 0,
        version: "",
        context: "",
        releaseScope: 1,
        softtype: 0,
      },
      fileList: [],
      action: "",
      drawerTitle: "",
      disabledTitles: ["升级详情"],
      actions: {
        new: "/system/clientversioninfo/uploadClient",
        update: "/system/clientversioninfo/updateUpgrade",
      },
    };
  },
  methods: {
    toPath(path, data) {
      const { id } = data;
      this.$router.push({
        path,
        query: {
          id,
        },
      });
    },
    handleRelease(data) {
      releaseStatus({
        id: data.id,
        releaseState: data.releaseState == 1 ? 0 : 1,
      }).then((res) => {
        this.getList();
      });
    },
    handleItem(data, drawerTitle) {
      this.drawerTitle = drawerTitle;
      this.addForm = {
        ...this.initAddForm,
      };
      this.fileList = [];
      this.action = this.actions.update;
      clientVersionInfoById(data.id).then((res) => {
        const _data = Object.assign({}, this.addForm, res.data);
        _data.versionTag = res.data.versionTag;
        if (_data.params) delete _data.params;
        const path = res.data.zipPath;
        this.addForm = _data;
        this.addForm.usedVersionTag = res.data.versionTag;
        this.fileList.push({
          name: res.data.fileName,
          path,
        });
        this.changeOpen();
      });
    },
    addItem() {
      this.drawerTitle = "新增记录";
      this.addForm = {
        ...this.initAddForm,
      };
      this.fileList = [];
      this.action = this.actions.new;
      this.changeOpen();
    },
    success() {
      this.addForm = {
        ...this.initAddForm,
      };
      this.$refs.upload.$refs.upload.clearFiles();
      this.changeOpen();
      this.getList();
    },
    commitData() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return false;
        if (!this.$refs.upload.$refs.upload.uploadFiles.length) {
          this.$message.warning("请选择附件");
          return;
        }
        const formData = new FormData();
        Object.keys(this.addForm).forEach((key) => {
          formData.append(key, this.addForm[key]);
        });
        formData.append(
          "file",
          this.$refs.upload.$refs.upload.uploadFiles[0].raw
        );
        const _this = this;
        jq.ajax({
          url: this.getVueBaseApi() + this.action, //后台请求
          type: "POST",
          cache: false,
          headers: {
              Authcollector: "Bearer " + this.$store.state.token,
          },
          data: formData,
          processData: false,
          contentType: false,
          async: false,
        })
          .done(function (res) {
            if (res.code !== 200) {
              _this.$message.error(res.msg);
            } else {
              _this.$message.success(res.msg);
              _this.success();
            }
          })
          .fail(function (res) {
            _this.$message.error(res.msg);
          });

        // if (
        //   this.$refs.upload.$refs.upload.uploadFiles[0]?.status != "success"
        // ) {
        //   this.$refs.upload.$refs.upload.submit();
        // } else {
        //   const params = {
        //     ...this.addForm,
        //   };
        //   updateclientVersionInfoById(params).then((res) => {
        //     this.success();
        //   });
        // }
      });
    },
    query() {
      this.pageData.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true
      const params = {
        currentPage: this.pageData.page,
        pageSize: this.pageData.pageSize
      };
      clientVersionInfoList(params)
        .then((res) => {
          this.maxA = res.data.maxA + 1;
          this.maxB = res.data.maxB + 1;
          this.initAddForm.versionTag = this.maxA;
          this.pageData.total = res.data.count;
          this.tableData = res.data?.list || [];
          this.loading = false
        })
        .catch((err) => {
          this.pageData.total = 0;
          this.tableData = [];
          this.loading = false
        });
    },
  },
  computed: {
    canDown() {
      return this.hasPermi("system:clientversioninfo:downloadFile");
    },
    maxVal() {
      return this.addForm.softtype == 0 ? this.maxA : this.maxB;
    },
  },
  watch: {
    "addForm.softtype"(val) {
      if (val == 0) {
        this.addForm.versionTag = this.maxA;
      } else {
        this.addForm.versionTag = this.maxB;
      }
    },
  },
  created() {
    this.getList();
  },
  components: { Upload },
};
</script>
